import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class MemberExtensionApplicationFormjs {
    constructor() {
        this.running = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    init(provinces) {


    }


    async postMemberExtensionApplicationForm(e, tokenId, successMessageId, failedMessageId, loadingId, inputSectionId, iconId, successIconUrl) {
        e.preventDefault();
        var that = this;
        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.hideById("failedExtensionMessage");
        that.utilsjs.showById(loadingId);
        document.getElementById(tokenId).value = await grecaptcha.execute(SiteSettings.GoogleRecaptchaKey, { action: 'memberExtensionApplicationFormPage' });

        if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'MemberExtensionApplicationFormPost', 'Module') === '201') {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(successMessageId);
            that.utilsjs.hideById(failedMessageId);
            that.utilsjs.hideById("failedExtensionMessage");
            that.utilsjs.hideById(inputSectionId);
            document.getElementById(iconId).src = successIconUrl;
        } else {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("failedExtensionMessage");
            that.utilsjs.hideById(successMessageId);

        }
        button.disabled = false;
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/memberExtensionApplicationForm.js